import React from "react";
import autoBind from 'react-autobind';
//
import CustomComponent from '@/components/CustomComponent';
import WhiteBox from '@/views/commonComponents/WhiteBox';
import CommonLoadingView from '@/views/commonComponents/CommonLoadingView';
import Utils from '@/components/Utils';
import config from '@/config/config';
//
import { Layout, Form, Input, Button, Row, Col, Divider, Table, Tooltip, Popconfirm, message, InputNumber } from 'antd';
import PageHeader from '@/components/PageHeader/PageHeader';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
//
export default class AdminUnitsView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      isLoading: false,
      data: [],
      isEditing: false,
      editingObject: {},
      sortedInfo: null,
    };
  }

  componentDidMount() {
    document.title = `${config.ApplicationName} - Units`;
    this._fetch();
  }

  handleManageClick(option) {
    this.props.app.urlManager.pushPage(option.route);
  }

  handleDelete(item) {
    this._delete(item.id);
  }

  handleEdit(item) {
    this.form.setFieldsValue(item);
    this.setState({ isEditing: true, editingObject: item });
  }

  handleCancelEdit() {
    this.form.resetFields();
    this.setState({ isEditing: false, editingObject: null });
  }

  async handleAddOrSave() {
    const formData = await this.form.validateFields();
    if (this.state.isEditing) this._edit(formData);
    else this._add(formData);
  }

  handleFilterChange(pagination, filters, sorter) { this.setState({ sortedInfo: sorter }); }
  
  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};
    const props = { onChange: this.handleFilterChange, rowKey: 'id', loading: this.props.isLoading };

    const columns = [
      { title: 'Unit Number', dataIndex: 'number', key: 'number', width: 150,
        sorter: (a, b) => a.number.localeCompare(b.number),
        sortOrder: sortedInfo.columnKey === 'number' && sortedInfo.order
      },
      { title: 'Description', dataIndex: 'description', key: 'description', width: 250,
        sorter: (a, b) => a.description.localeCompare(b.description),
        sortOrder: sortedInfo.columnKey === 'description' && sortedInfo.order
      },
      { title: 'Actions', width: 80, key: 'Actions',
        render: props => {
          return (<span className='tableButtonContainer'>
                    <Tooltip placement="bottomLeft" title='Delete Unit'>
                      <Popconfirm title={`Do you really want to delete '${props.description}'?`} placement="bottomRight" onConfirm={this.handleDelete.bind(this, props)} okText="Yes" cancelText="No">
                        <Button variant="none" icon={<DeleteOutlined />} shape="circle"/>
                      </Popconfirm>
                    </Tooltip>{' '}
                    <Tooltip placement="bottomLeft" title='Edit Unit'>
                      <Button variant="none" icon={<EditOutlined />} shape="circle" onClick={this.handleEdit.bind(this, props)}/>
                    </Tooltip>
                  </span>);
        }
      }
    ];

    return (
      <Layout.Content className="pageContent">
        <CommonLoadingView isLoading={this.state.isLoading} isFixed />
        <PageHeader title="Units" onBack={() => window.history.back()} />
        <Layout.Content>
          <WhiteBox>
            <Form layout="vertical" {...Utils.propagateRef(this, 'form')}>
              <Row>
                <Col span={4}>
                  <Form.Item name="number" label="Unit Number" rules={[{ required: true, message: 'Please, type the unit number!' }]}>
                    <InputNumber style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col span={8} offset={1}>
                  <Form.Item name="description" label="Description" rules={[{ required: true, message: 'Please, type the description!' }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={4} offset={1}>
                  <Button style={{ marginTop: 30 }} type="primary" onClick={this.handleAddOrSave}>
                    {this.state.isEditing ? 'Save' : 'Add'}
                  </Button>
                  {this.state.isEditing && (
                    <Button style={{ marginTop: 30 }} type="link" onClick={this.handleCancelEdit}>Cancel</Button>
                  )}
                </Col>
              </Row>
            </Form>

            <Divider />

            <Table style={{ opacity: this.state.isEditing ? 0.3 : 1 }} dataSource={this.state.data} columns={columns} {...props} />
          </WhiteBox>
        </Layout.Content>
      </Layout.Content>
    )
  }

  // API Calls
  async _fetch() {
    this.startLoading();
    //request
    const resp = await this.props.app.api.unitsNumber.getAll();
    if (!this._isMounted) return;
    if (resp.statusCode == 200 && resp.body && resp.body.unitsNumbers) {
      this.setState({ data: resp.body.unitsNumbers, isLoading: false });
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
      this.stopLoading(true);
    }
  }

  async _add(data) {
    this.startLoading();
    //request
    const resp = await this.props.app.api.unitsNumber.create(data);
    if (!this._isMounted) return;
    if (resp.statusCode == 200) {
      message.success('Unit number successfully created!');
      this.props.app.refreshConfig();
      this.form.resetFields();
      this._fetch();
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
      this.stopLoading(true);
    }
  }

  async _edit(data) {
    this.startLoading();
    //request
    const resp = await this.props.app.api.unitsNumber.update({
      id: this.state.editingObject.id, ...data,
    });

    if (!this._isMounted) return;
    if (resp.statusCode == 200) {
      message.success('Unit number successfully updated!');
      this.props.app.refreshConfig();
      this.form.resetFields();
      this.handleCancelEdit();
      this._fetch();
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
      this.stopLoading(true);
    }
  }

  async _delete(id) {
    this.startLoading();
    //request
    const resp = await this.props.app.api.unitsNumber.remove(id);
    if (!this._isMounted) return;
    if (resp.statusCode == 200) {
      message.success('Unit number successfully removed!');
      this.props.app.refreshConfig();
      this._fetch();
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
      this.stopLoading(true);
    }
  }
}
